import { Box, Button, Paper, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import { useNavigate } from "react-router-dom";


const colorMapping = [
  "#FFA800",
  "#8A50FC",
  "#1BC5BD",
  "#F65464",
  "#FF8C00",
  "#4CAF50",
  "#2196F3",
  "#FFEB3B",
  "#795548",
  "#FF5722",
  "#607D8B",
  "#9C27B0",
  "#CDDC39",
  "#00BCD4",
  "#FFC107",
  "#9E9E9E",
  "#3F51B5",
  "#673AB7",
  "#E91E63",
  "#4CAF50"
];

const FullViewPieChart = (Props) => {
  const [categoryData, setCategoryData] = useState({
    total: 0,
    data: [],
  })

  const navigate = useNavigate();
  useEffect(() => {


    let total = 0
    let dataList = []

    const sortedData = Props.data.sort((a, b) => b.count - a.count);

    sortedData.map((item, index) => {
      total = total + item?.count
      dataList.push({
        name: item?.name,
        y: item?.count,
        color: colorMapping?.[index]
      })
    })

    const data = [];
    Props?.data?.map((item) => {
      data.push([item?.name, item?.count]);
    });
    setCategoryData({
      data: dataList,
      total: total
    })
    const PieChartData = {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 60,
          beta: 0,
        },
      },
      title: {
        text: "",
        align: "left",
      },
      exporting: false,
      subtitle: {
        text: "",
        align: "left",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: "<b>{point.percentage:.1f}%</b>",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          depth: 35,
          dataLabels: {
            enabled: false,
            // format: "{point.name}",
          },
        },
      },
      series: [
        {
          type: "pie",
          name: "Share",
          data: dataList,
        },
      ],
    };

    Highcharts.chart("FullViewPieChart", PieChartData);
  }, [Props.data]);
  return (
    <>
      <Paper
        sx={{
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            padding: "20px 20px 20px 20px",
          }}
        >
          <Box>
            <div
              id="FullViewPieChart"
              style={{ width: "100%", height: "550px" }}
            ></div>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridGap: "20px",
            }}
          >
            {categoryData.data.map((item) => {
              return (
                <Box
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigate("/defects", {
                      state: { categoryDefectsdata: item.name }
                    });
                  }}>
                  <Typography
                    sx={{ color: item.color, fontWeight: "600", fontSize: "18px" }}
                  >
                    {(item.y * 100 / categoryData.total).toFixed(1)}%
                  </Typography>
                  <Typography sx={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}>{item.name}</Typography>
                </Box>
              )
            })}
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default FullViewPieChart;
